// 导入请求数据的 request 模块
import request from '@/utils/request'

// 查询图片信息
export const selectLecture = (currentPage, pageSize) => {
  return request.get('/home/lecture/select', {
    params: {
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
